/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Grid } from '@material-ui/core';
import { Provider } from 'common/helpers/context';
import AssessmentSessions from './components/AssessmentSessions';
import YourPassports from './components/YourPassports';
import PassportRequestTabular from './components/PassportRequestTabular';

import { useStyles } from './CandidatePortal.style';
import { getCandidateAssignments } from './actions/getCandidateAssignments';
import { getPassportRequest } from './actions/getPassportRequest';

const CandidatePortal = (props) => {
  const classes = useStyles();

  const { userInfo, assignments, anonResults, passportRequests } = props;
  const { candidates } = userInfo;

  useEffect(() => {
    if (userInfo) {
      props.getCandidateAssignments(userInfo.id);
      props.getPassportRequest(userInfo.id);
    }
  }, [userInfo]);

  // The candidate whose technical assessment is still in flight drives the
  // "Session X of Y" control. Source the id from assignments (always fetched for a
  // candidate via getCandidateAssignments) rather than bookings, whose payload only
  // includes candidates that already have a booking row — otherwise AssessmentSessions
  // is silently gated off. candidate.id is the Portal candidate id, which equals the
  // Assessment attempt.user_id the session-state lookup is keyed on. AssessmentSessions
  // itself self-hides unless session-state is paused/in_progress.
  const techAssignment = assignments.find(
    (assignment) =>
      assignment.candidate && !assignment.candidate.flags.doneTechAssessment,
  );
  const techCandidateId = techAssignment ? techAssignment.candidate.id : null;

  const getContext = () => ({
    userInfo,
    candidates,
    assignments,
    anonResults,
    passportRequests,
  });

  return (
    <Provider value={getContext()}>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={5}>
          <AssessmentSessions
            candidateId={techCandidateId}
            doneSelfAssessment={Boolean(
              techAssignment?.candidate?.flags?.doneSelfAssessment,
            )}
          />
          <YourPassports shouldHide />
          <PassportRequestTabular
            isOutbound
            title="Passport Requests You've Made"
            passportRequests={passportRequests.outbound}
          />
          <PassportRequestTabular
            title="Requests Awaiting Your Approval"
            passportRequests={passportRequests.inbound}
          />
        </Grid>
      </Container>
    </Provider>
  );
};

CandidatePortal.propTypes = {
  userInfo: PropTypes.object.isRequired,
  assignments: PropTypes.array.isRequired,
  passportRequests: PropTypes.object.isRequired,
  getCandidateAssignments: PropTypes.func.isRequired,
  getPassportRequest: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { dashboard, candidatePortal } = state;
  const { userInfo } = dashboard;
  const { assignments, passportRequests } = candidatePortal;
  return { userInfo, assignments, passportRequests };
};

const mapDispatchToProps = (dispatch) => ({
  getCandidateAssignments: (userId) =>
    dispatch(getCandidateAssignments(userId)),
  getPassportRequest: (userId) => dispatch(getPassportRequest(userId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CandidatePortal);
